import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";
import PaxSession from "models/session/pax-session";
import AnalyticsService from "services/analytics/analytics";
import useMutatedPagePath from "./useMutatedPagePath";

const useConversionAnalytics = () => {
  const [path, title, location] = useMutatedPagePath();

  const allPassengersBecameReadyToFly = (
    previousPaxSessions: PaxSession[],
    paxSessions: PaxSession[]
  ): boolean => {
    const previousAllPaxReadyToFly = previousPaxSessions.every(
      (p) =>
        p.checklist.resolutionStatus === ChecklistResolutionStatus.ReadyToFly
    );
    const currentAllPaxReadyToFly = paxSessions.every(
      (p) =>
        p.checklist.resolutionStatus === ChecklistResolutionStatus.ReadyToFly
    );

    return !previousAllPaxReadyToFly && currentAllPaxReadyToFly;
  };

  const sendConversionEvents = (
    previousPaxSessions: PaxSession[],
    paxSessions: PaxSession[]
  ) => {
    paxSessions.forEach((paxSession) => {
      const previousPaxSession = previousPaxSessions.find(
        (p) => p.paxSessionId === paxSession.paxSessionId
      );

      if (
        previousPaxSession?.checklist.resolutionStatus !==
          ChecklistResolutionStatus.ReadyToFly &&
        paxSession.checklist.resolutionStatus ===
          ChecklistResolutionStatus.ReadyToFly
      ) {
        AnalyticsService.shared.trackEvent(
          "pax_ready_to_fly",
          {
            page_path: path,
            content_group: path,
            page_title: title,
            page_location: location,
          },
          // isScanRelated
          false
        );

        if (allPassengersBecameReadyToFly(previousPaxSessions, paxSessions)) {
          AnalyticsService.shared.trackEvent(
            "all_paxes_ready_to_fly",
            {
              page_path: path,
              content_group: path,
              page_title: title,
              page_location: location,
            },
            // isScanRelated
            false
          );
        }
      }

      if (
        previousPaxSession?.checklist.resolutionStatus ===
          ChecklistResolutionStatus.ReadyToFly &&
        paxSession.checklist.resolutionStatus !==
          ChecklistResolutionStatus.ReadyToFly
      ) {
        AnalyticsService.shared.trackEvent(
          "pax_became_unresolved",
          {
            page_path: path,
            content_group: path,
            page_title: title,
            page_location: location,
          },
          // isScanRelated
          false
        );
      }
    });
  };

  return sendConversionEvents;
};

export default useConversionAnalytics;
